module.exports = __webpack_public_path__ + "static/media/shape-1.9f91913f.svg";